/**
 * USER-RECAP.UTILS
 * Pure rule : the lines of the summary of a collaborator (what is filled and what is missing), for the lists of the project
 */

interface UserLike {
  firstname?: string | null
  lastname?: string | null
  email?: string | null
  phone?: string | null
  address?: string | null
  language?: string | null
}

export interface UserRecapLabels {
  firstname: string
  lastname: string
  email: string
  phone: string
  address: string
  language: string
  missing: string //Displayed when the field is empty
}

const filled = (value: string | null | undefined): string => (value || "").trim()

//One line per field : "Label : value", or "Label : -" when the field is empty
export function getUserRecapLines(user: UserLike, labels: UserRecapLabels): string[] {
  const line = (label: string, value: string) => label + " : " + (value || labels.missing)
  return [
    line(labels.firstname, filled(user.firstname)),
    line(labels.lastname, filled(user.lastname)),
    line(labels.email, filled(user.email)),
    line(labels.phone, filled(user.phone)),
    line(labels.address, filled(user.address)),
    line(labels.language, filled(user.language).toUpperCase())
  ]
}
